import { win } from "../common/namespaces";

/**
 *
 *
 *
 *
 *
 *
 *
 */
export const { fragment } = win.o_util;
export const { deserialize, get, push, remove, serialize, set } = fragment ?? {};
